import React, { useEffect, useMemo, useState } from 'react';
import type { Content } from '@jwp/ott-common/types/config';
import type { PlaylistItem } from '@jwp/ott-common/types/playlist';

import type { ScreenComponent } from '../../../../../types/screens';
import ShelfList from '../../../../containers/ShelfList/ShelfList';
import Hero from '../../../../components/Hero/Hero';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';
import { getLocalStorageValue } from '@jwp/ott-common/src/constants';
const parsePlaylistIds = (input: unknown): Content[] => {
  const playlistIds = typeof input === 'string' ? input.replace(/\s+/g, '').split(',') : [];

  return playlistIds.map((id) => ({ type: 'playlist', contentId: id }));
};

const MediaHub: ScreenComponent<PlaylistItem> = ({ data }) => {
  // Hub may specify multiple playlists as a CSV list of IDs or a single playlist
  const rows = useMemo(() => parsePlaylistIds(data.playlists || data.playlist), [data.playlist, data.playlists]);
  const { config } = useConfigStore.getState();
  const LocalStorageValue = getLocalStorageValue();
  const defaultLanguage = config?.custom?.defaultLanguage;
  const [imageUrl, setImageUrl] = useState<string>();
  const customParam = config?.custom;
  const { isThumbnailLocalized } = customParam ?? {};
  let selectedTitle;
  let selecteddescription;
  if (defaultLanguage === 'es') {
    if (LocalStorageValue === 'es' || LocalStorageValue === undefined) {
      selectedTitle = data?.title;
      selecteddescription = data?.description;
    } else if (LocalStorageValue === 'en' && data?.['title-en'] !== undefined) {
      selectedTitle = data?.['title-en'];
      selecteddescription = data?.['description-en'];
    } else {
      selectedTitle = data?.title;
      selecteddescription = data?.description;
    }
  } else if (defaultLanguage === 'en' || LocalStorageValue === 'en') {
    if (LocalStorageValue === 'en' || LocalStorageValue === undefined) {
      selectedTitle = data?.title;
      selecteddescription = data?.description;
    } else if (LocalStorageValue === 'es' || data?.title !== undefined) {
      selectedTitle = data?.['title-en'];
      selecteddescription = data?.['description-en'];
    } else {
      selectedTitle = data['title-en'];
      selecteddescription = data?.['description-en'];
    }
  } else {
    selectedTitle = data['title-en'];
    selecteddescription = data?.['description-en'];
  }

  // Effects
  useEffect(() => {
    (document.scrollingElement || document.body).scroll({ top: 0 });
    (document.querySelector('#video-details button') as HTMLElement)?.focus();
  }, [data]);

  const checkImageExists = async (url: any) => {
    try {
      const response = await fetch(url);
      if (response.url.includes('thumbnails')) {
        return false;
      } else {
        return response.ok;
      }
    } catch (error) {
      console.error('Error checking image existence:', error);
      return false;
    }
  };

  useEffect(() => {
    const determineImageUrl = async () => {
      let selectedImageUrl = data.backgroundImage;
      if (isThumbnailLocalized === 'true' && LocalStorageValue === 'en' && data?.contentType === 'hub' && !(await checkImageExists(data.backgroundImage))) {
        const enVerticalImageUrl = `https://img.jwplayer.com/v1/media/${data.mediaid}/images/horizontal-en.jpg`;
        if (await checkImageExists(enVerticalImageUrl)) {
          selectedImageUrl = enVerticalImageUrl;
        } else {
          selectedImageUrl = data.backgroundImage;
        }
      } else {
        selectedImageUrl = data.backgroundImage;
      }
      setImageUrl(selectedImageUrl);
    };

    determineImageUrl();
  }, [isThumbnailLocalized, LocalStorageValue, data]);

  return (
    <header>
      {imageUrl && selectedTitle && selecteddescription && <Hero image={imageUrl} title={selectedTitle} description={selecteddescription} />}
      <ShelfList rows={rows} isHubContent />
    </header>
  );
};

export default MediaHub;
